import cx from 'classnames';
import React from 'react';

import { Grid } from 'components/Grid/Grid';
import { toEntry, AppType, Link, WithCMS } from 'services/cms/typesUtil';
import type { AccordionAssembly, Subject } from '../../api/contentful/contentTypes.cloverdotcom';
import { ButtonLinkV2 } from '../Button/ButtonLinkV2';
import { GridContainer } from '../GridContainer/GridContainer';
import { TextV2 } from '../TextV2/TextV2';
import styles from './ImageTextModule.module.scss';
import { TEXT_MODULE_TEST_ID } from './TextModule.const';

type TextModuleProps = AppType.Component<{
  isImageTransparent: boolean;
  isImageAlignLeft: boolean;
  textGridContainerRef: React.Ref<HTMLDivElement>;
  textGridItemRef: React.Ref<HTMLDivElement>;
  accordion: AccordionAssembly;
  headline: string;
  description: string;
  imageTextModuleCta: Subject[];
}>;

export const TextModule: React.FC<TextModuleProps> = ({
  isImageTransparent,
  isImageAlignLeft,
  textGridContainerRef,
  textGridItemRef,
  accordion,
  headline,
  description,
  imageTextModuleCta,
}) => {
  return (
    <GridContainer
      className={cx(styles.imageTextModuleGridContainer, {
        [styles.imageTextModuleTransparentImgGrid]: isImageTransparent,
      })}
      ref={textGridContainerRef}
    >
      {isImageAlignLeft && <Grid item xs={false} md={6} />}
      <Grid
        item
        xs={12}
        md={6}
        className={cx(styles.imageTextModuleGrid, {
          [styles.imageTextModuleGridAlignLeft]: !isImageAlignLeft,
          [styles.imageTextModuleGridAlignRight]: isImageAlignLeft,
        })}
        ref={textGridItemRef}
      >
        {!accordion?.items?.length && (
          <div
            className={cx(styles.imageTextModuleTextContainer, {
              [styles.imageTextModuleItemContainerAlignLeft]: isImageAlignLeft,
              [styles.imageTextModuleItemContainerAlignRight]: !isImageAlignLeft,
            })}
          >
            <TextV2
              variant="h3-bold"
              tagName="h3"
              className={styles.imageTextModuleHeadline}
              value={headline}
            />
            <TextV2
              variant="body"
              tagName="p"
              value={description}
              className={styles.imageTextModuleDescription}
              isMarkdown
            />
            {imageTextModuleCta?.length && (
              <ul data-testid={TEXT_MODULE_TEST_ID.buttonContainer}>
                {imageTextModuleCta?.map((cta, index) => (
                  <li key={index} data-id={`headlineButton${index}`}>
                    <ButtonLinkV2
                      className={styles.imageTextModuleButton}
                      entry={toEntry(cta as WithCMS<Link>)}
                    />
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </Grid>
      {!isImageAlignLeft && <Grid item xs={false} md={6} />}
    </GridContainer>
  );
};
